import React, { useState, useEffect } from "react";
import {STATE_STAMP_DUTY_RATE,calculateStampDuty,formatCurrency,parseNumber,clamp} from "../utils/calculatorLogic";
import RangeSlider from "./common/RangeSlider";
import { sharePdf } from "../utils/pdf/sharePdf";
import { mapStampDutyData } from "../utils/pdf/pdfMapper";
import { createPdfCacheManager } from "../utils/pdf/pdfCacheManager";
import { generatePdf } from "../utils/pdf/generatePdf";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ReadMoreText from "./ReadMoreText";
ChartJS.register(ArcElement, Tooltip, Legend);

function StampDutyCalculator({ showHeader, headerTitle, headerDesc }) {
  const [state, setState] = useState("Andhra Pradesh");
  const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);
  const [isSharingPdf, setIsSharingPdf] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [propertyValue, setPropertyValue] = useState(8000000);
  const { rate, amount } = calculateStampDuty(state, propertyValue);
  const stampDutyAmount = Math.round(amount);
  const APPLY_URL = "/property-loan/apply";
  const DEFAULT_HEADER_TITLE = "Stamp Duty Calculator";
  const DEFAULT_HEADER_DESC = "Calculate the stamp duty payable based on your property value and location.";
  const shouldShowHeader = showHeader?.toLowerCase() === "true";
  const resolvedHeaderTitle = headerTitle?.trim() || DEFAULT_HEADER_TITLE;
  const resolvedHeaderDesc = headerDesc?.trim() || DEFAULT_HEADER_DESC;

  const chartData = {
    labels: ["Stamp Duty", "Property Value"],
    datasets: [
      {
        data: [stampDutyAmount, propertyValue - stampDutyAmount],
        backgroundColor: ["#e04644", "#5563c1"],
        borderWidth: 0,
        cutout: "70%",
        hoverBorderWidth: 2,
        hoverBorderColor: ["#E04848", "#5168C1"],
        hoverOffset: 0,
        borderRadius: 0,
        spacing: 0
      },
    ],
  };

  const chartOptions = {
    rotation: -90,
    circumference: 180,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
  enabled: false, // ❗ disable default
  external: function (context) {
    let tooltipEl = document.getElementById("glass-tooltip");

    // create element
    if (!tooltipEl) {
      tooltipEl = document.createElement("div");
      tooltipEl.id = "glass-tooltip";
      tooltipEl.innerHTML = `<div class="glass-tooltip-inner"></div>`;
      document.body.appendChild(tooltipEl);
    }

    const tooltip = context.tooltip;

    // hide
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    const data = tooltip.dataPoints?.[0];
    if (!data) return;

    // set content
    tooltipEl.querySelector(".glass-tooltip-inner").innerHTML = `
      <div class="tooltip-title">${data.label}</div>
      <div class="tooltip-value">₹ ${data.raw.toLocaleString()}</div>
    `;

    // position
    const rect = context.chart.canvas.getBoundingClientRect();

tooltipEl.style.opacity = 1;
tooltipEl.style.position = "absolute";
tooltipEl.style.left =
  rect.left + window.scrollX + tooltip.caretX + "px";
tooltipEl.style.top =
  rect.top + window.scrollY + tooltip.caretY + "px";
tooltipEl.style.transform = "translate(-50%, -100%)";
tooltipEl.style.pointerEvents = "none";
  }
},
    },
  };
  const pdfManager = React.useRef(createPdfCacheManager({pdfType: "stampDuty",generatePdf,debounceMs: 400,})).current;

  const updateState = (val) => { pdfManager.markInteracted(); setState(val); };
  const updatePropertyValue = (val) => { pdfManager.markInteracted(); setPropertyValue(val); };

  useEffect(() => {
    const mapped = mapStampDutyData({state,propertyValue,rate,amount: stampDutyAmount,});
    setPdfData(mapped);
    pdfManager.scheduleCache(mapped);
  }, [state,propertyValue,rate,stampDutyAmount]);

  const handlePdfDownload = async () => {
    if (!pdfData) return;
    setIsDownloadingPdf(true);
    try {
      const blob = await pdfManager.getBlob(pdfData);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Stamp_Duty_Report.pdf";
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setIsDownloadingPdf(false);
    }
  };
const shadowPlugin = {
  id: "shadowPlugin",
  beforeDraw(chart) {
    const { ctx } = chart;

    ctx.save();

    ctx.shadowColor = "rgba(0,0,0,0.32)"; // #00000052
    ctx.shadowBlur = 7.5;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 5;
  },
  afterDraw(chart) {
    chart.ctx.restore();
  }
};
const hoverGlowPlugin = {
  id: "hoverGlowPlugin",
  afterDatasetDraw(chart, args) {
    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);

    meta.data.forEach((arc, index) => {
      if (arc.active && index === 0) { // only blue part
        ctx.save();

        ctx.shadowColor = "#5168C1";
        ctx.shadowBlur = 15;

        arc.draw(ctx);

        ctx.restore();
      }
    });
  }
};
  const handlePdfShare = async () => {
    if (!pdfData) return;
    setIsSharingPdf(true);
    try {
      const blob = await pdfManager.getBlob(pdfData);
      await sharePdf(blob, "Stamp_Duty_Report.pdf");
    } finally {
      setIsSharingPdf(false);
    }
  };

  return (
  <div className="calc mt-4">
  {shouldShowHeader && (
            <div className="paradescwrap mobile-only-header">
              <p className="title large-body bold">{resolvedHeaderTitle}</p>
              <div className="description">
                <p className="description-text regular-body regular neutral800">
                  <ReadMoreText text={resolvedHeaderDesc} limit={200} />
                </p>
              </div>
            </div>
          )}
    <div class="wrapthechart">
        <div class="chartwrapperformobile">
      <div className="chart-wrapper-mobile">
              <Doughnut data={chartData} options={chartOptions} plugins={[shadowPlugin, hoverGlowPlugin]}/>
              <div className="chart-center">
                <p class="your-emi">Stamp Duty</p>
                <p className="currency">₹ {formatCurrency(stampDutyAmount)}</p>
                <span>{rate}% Rate</span>
              </div>
            </div>
            <div class="donughtmobile">
            <div className="legend-mobile d-flex">
              <div className="legend-item"><span className="dot interest-dot"></span><span className="principal font-w-700 font-14 neutral800">Stamp Duty</span></div>
              <div className="legend-item"><span className="dot principal-dot"></span><span className="font-w-700 font-14 neutral800 interest">Remaining Property Value</span></div>
            </div>
            </div>
        </div>
    <div className="emi-container max-w-desktop">
      <div className="emi-layout">
        <div className="emi-left">
          {shouldShowHeader && (
            <div className="paradescwrap">
              <p className="title large-body bold">{resolvedHeaderTitle}</p>
              <div className="description">
                <p className="description-text regular-body regular neutral800">
                  <ReadMoreText text={resolvedHeaderDesc} limit={200} />
                </p>
              </div>
            </div>
          )}
          <div className="input-group">
            <div className="input-header">
              <label>State (Property Location)</label>
              <div className="input-box">
                <select value={state} onChange={(e) => updateState(e.target.value)}>
                  {Object.keys(STATE_STAMP_DUTY_RATE).map((stateName) => (
                    <option key={stateName} value={stateName}>
                      {stateName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="input-group">
            <div className="input-header">
              <label>Property Value</label>
              <div className="input-box">
                <span>₹</span>
                <input type="text" value={formatCurrency(propertyValue)} min="100000" max="20000000" step="100000" onChange={(e) => updatePropertyValue(clamp(parseNumber(e.target.value), 0, 20000000)) }/>
              </div>
            </div>
            <RangeSlider
              min={100000} max={20000000} step={100000} value={propertyValue}
              onChange={(e) => updatePropertyValue(clamp(Number(e.target.value), 100000, 20000000))}
              formatValue={(val) => {
                if (val >= 10000000) {
                  return `₹ ${(val / 10000000).toFixed(2)} Cr`;
                }
                return `₹ ${(val / 100000).toFixed(0)} L`;
              }}
              marks={[
                { value: 100000, label: "1L" },
                { value: 4000000, label: "40L" },
                { value: 8000000, label: "80L" },
                { value: 12000000, label: "1.2Cr" },
                { value: 16000000, label: "1.6Cr" },
                { value: 20000000, label: "2Cr" }
              ]}
            />
          </div>
        </div>
        <div className="emi-right">
           <div class="emibg">
          <div className="emi-curvature">
            <div className="chart-wrapper">
              <Doughnut data={chartData} options={chartOptions} />
              <div className="chart-center">
                <p class="your-emi">Stamp Duty</p>
                <p className="currency">₹ {formatCurrency(stampDutyAmount)}</p>
                <span>{rate}% Rate</span>
              </div>
            </div>

            <div className="legend">
              <div className="legend-item"><span className="dot interest-dot"></span><span className="principal font-w-700 font-14 neutral800">Stamp Duty</span></div>
              <div className="legend-item"><span className="dot principal-dot"></span><span className="font-w-700 font-14 neutral800 interest">Remaining Property Value</span></div>
            </div>

            <div className="summary">
              <div className="summary-row">
                <span className="font-w-500 font-14 neutral600 prin">Property Value</span>
               <span className="rupee font-w-700 font-14 neutral1000">₹ <span className="numericvalue rupee font-w-500 font-14 neutral1000">{formatCurrency(propertyValue)}</span></span>
              </div>
              <div className="summary-row">
                <span className="font-w-500 font-14 neutral600 interesttotal">Stamp Duty Rate</span>
                <span className="rupee font-w-700 font-14 neutral1000">{rate}%</span>
              </div>
              <div className="summary-row">
                <span className="font-w-500 font-14 neutral600"> Stamp Duty Payable</span>
                <span className="rupee font-w-700 font-14 neutral1000">₹ <span className="numericvalue rupee font-w-500 font-14 neutral1000">{formatCurrency(stampDutyAmount)}</span></span>
              </div>
            </div>

            <div className="card-actions">
              <div className="icon-group">
                <button className="icon-btn" onClick={handlePdfShare} disabled={isSharingPdf}>
                    <img src={`/documents/d/global/share-icon`} alt="Share"/>
                    <span className="caption-body neutral800">
                      {isSharingPdf ? "Please wait.." : "Share"}
                    </span>
                </button>
                <button className="icon-btn" onClick={handlePdfDownload} disabled={isDownloadingPdf}>
                    <img src={`/documents/d/global/download-icon`} alt="Download" />
                    <span className="caption-body neutral800">
                      {isDownloadingPdf ? "Please wait.." : "Download"}
                    </span>
                </button>
              </div>
            </div>
             </div>
          </div>

          <div className="left-actions other-calculator">
            <button className="apply-btn btn primary-button" onClick={() => { globalThis.location.href = APPLY_URL;}}>Apply Now</button>
            <button className="callback-btn shimmer-button" onClick={() => globalThis.openApplyModal?.()}>
              <span className="shimmer-text">Get a call back</span>
              <svg className="shimmer-border" viewBox="0 0 232 48" preserveAspectRatio="none">
                <rect x="1" y="1" width="230" height="46" rx="24" ry="24" pathLength="1"></rect>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="disclaimer-box">
          <img src={`/documents/d/global/cal-bottom-desc-icon`} alt="cal-bottom-desc"/>
          <span className="regular-body regular neutral800 mb-0"> Please note that this is a tentative stamp duty only, however, the applicants are advised to cross-check regarding the latest stamp duty applicable at the time of execution of sale deed/conveyance deed, etc.</span>
      </div>
    </div>
    </div>
	</div>
  );
}

export default StampDutyCalculator;
